/* eslint-disable react/self-closing-comp */
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { StatusMessage } from '@hvcgroep/design-system';
import './style.scss';
import Button from '../../../../shared/components/Button';
import { heatApi } from '../../store/slices/HeatApi';

type Props = {
  sjvGJ: string,
  ean: string,
};

const PricingStructureTable = (props: Props) => {
  const { t } = useTranslation();
  const { sjvGJ, ean } = props;

  const { data: offer, status: offerStatus } = heatApi.endpoints.getOffer.useQuery({ ean, sjvGJ });
  const [trigger] = heatApi.endpoints.getOffer.useLazyQuerySubscription();

  if ((offerStatus === 'pending' || offerStatus === null) && !offer) {
    return (
      <div>Loading</div>
    );
  }

  if (offerStatus === 'rejected' || !offer) {
    return (
      <StatusMessage type="error">
        <p className="mb-4">{t('registration_desk.server_errors.get_pricing_structure')}</p>
        <Button
          variation="center"
          onClick={() => trigger({ ean, sjvGJ })}
        >
          {t('registration_desk.buttons.retry')}
        </Button>
      </StatusMessage>
    );
  }
  return (
    <div className="PricingStructureTable">
      <table>
        <tbody>
          <tr>
            <td><Trans i18nKey="registration_desk.pricing_structure_table.annual_consumption.title">{' '}<br />{' '}</Trans> <span>{t('registration_desk.pricing_structure_table.annual_consumption.heat', { annualCost: `${offer.Details[0].Quantity}` })}</span></td>
            <td><span>x</span></td>
            <td><Trans i18nKey="registration_desk.pricing_structure_table.price_per_gj.title">{' '}<br />{' '}</Trans> <span>{t('registration_desk.pricing_structure_table.price_per_gj.price', { gjCost: `${offer.Details[0].UnitPrice}` })}</span></td>
            <td><span>=</span></td>
            <td><Trans i18nKey="registration_desk.pricing_structure_table.total_annual_cost.title">{' '}<br />{' '}</Trans> <strong>{t('registration_desk.pricing_structure_table.total_annual_cost.price', { totalAnnualCost: `${offer.Details[0].Amount}` })}</strong></td>
          </tr>
          <tr>
            <td>{t('registration_desk.pricing_structure_table.annual_fixed_cost.title')}</td>
            <td><strong>{t('registration_desk.pricing_structure_table.annual_fixed_cost.price', { fixedCost: `${offer.Details[1].Amount}` })}</strong></td>
          </tr>
          <tr>
            <th><strong>{t('registration_desk.pricing_structure_table.total_heading.title')}</strong></th>
            <th>{t('registration_desk.pricing_structure_table.total.yearly.price', { yearlyAmount: `${offer.YearAmount}` })} <span>{t('registration_desk.pricing_structure_table.total.yearly.title')}</span></th>
          </tr>
        </tbody>
      </table>
      <div className="PricingStructureTable__monthly">
        <div>
          <h4>{t('registration_desk.pricing_structure_table.total.monthly.price', { monthlyAmount: `${offer.MonthAmount}` })}</h4>
          <h5>{t('registration_desk.pricing_structure_table.total.monthly.title')}</h5>
        </div>
      </div>
    </div>
  );
};

export default PricingStructureTable;
